import React, { memo, useRef, useState } from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import { addIdProp, addTestIdProp } from 'utils/universal'
import BodyTypeSuvIcon from 'components/icons/body-type-suvs.svg'
import BodyTypeSedanIcon from 'components/icons/body-type-sedan.svg'
import BodyTypeUtilitarianIcon from 'components/icons/body-type-utilitarios.svg'
import BodyTypePickUpsIcon from 'components/icons/body-type-pick-ups.svg'
import BodyTypeHbIcon from 'components/icons/body-type-hb.svg'
import BodyTypeCoupesIcon from 'components/icons/body-type-coupes.svg'
import BodyTypeHybridIcon from 'components/icons/body-type-hybrid.svg'
import BodyTypeCrossOverIcon from 'components/icons/body-type-crossovers.svg'
import IconRightSmallArrow from 'components/icons/IconRightSmallArrow.svg'
import IconLeftArrow from 'components/icons/IconLeftArrow.svg'
import Tile from 'components/shared/Tile'
import sx from './styles'

const QuickLinks = (props) => {
  const {
    direction = 'row',
    title,
    description,
    titleStyles,
    varaintTitle = 'h3',
    testId: testIdProp,
    isOverflow = true,
    sxProps = {},
  } = props
  const [scrollX, setScrollX] = useState(0)
  const [scrolEnd, setScrolEnd] = useState(false)
  const { formatMessage: f } = useIntl()
  const searchUrl = f({ id: 'ROUTE_SEARCH' })
  const linksContainer = useRef(null)

  const slide = (shift) => {
    linksContainer.current.scrollLeft += shift
    setScrollX(scrollX + shift)
    if (
      Math.floor(
        linksContainer.current.scrollWidth - linksContainer.current.scrollLeft,
      ) <= linksContainer.current.offsetWidth
    ) {
      setScrolEnd(true)
    } else {
      setScrolEnd(false)
    }
  }

  const scrollCheck = () => {
    setScrollX(linksContainer.current.scrollLeft)
    if (
      Math.floor(
        linksContainer.current.scrollWidth - linksContainer.current.scrollLeft,
      ) <= linksContainer.current.offsetWidth
    ) {
      setScrolEnd(true)
    } else {
      setScrolEnd(false)
    }
  }

  const bodyTypes = [
    {
      icon: <BodyTypeSuvIcon />,
      name: f({ id: 'SUVS' }),
      href: `${searchUrl}/tipo-Camioneta%20SUV`,
      title: 'Autos seminuevos SUV',
    },
    {
      icon: <BodyTypeHbIcon />,
      name: f({ id: 'HATCHBACK' }),
      href: `${searchUrl}/tipo-Hatchback`,
      title: 'Autos seminuevos Hatchback',
    },
    {
      icon: <BodyTypeSedanIcon />,
      name: f({ id: 'SEDAN' }),
      href: `${searchUrl}/tipo-Sedan%204%20puertas`,
      title: 'Autos seminuevos Sedan',
    },
    {
      icon: <BodyTypeCoupesIcon />,
      name: f({ id: 'COUPES' }),
      href: `${searchUrl}/tipo-Coupe%202%20puertas`,
      title: 'Autos seminuevos Coupe',
    },
    {
      icon: <BodyTypeUtilitarianIcon />,
      name: f({ id: 'UTILITARIAN' }),
      href: `${searchUrl}/tipo-Van`,
      title: 'Autos seminuevos Utilitarios',
    },
    {
      icon: <BodyTypeHybridIcon />,
      name: f({ id: 'HYBRID' }),
      href: `${searchUrl}/combustible-hibrido-elec`,
      title: 'Autos seminuevos Híbridos',
    },
    {
      icon: <BodyTypePickUpsIcon />,
      name: f({ id: 'PICKUPS' }),
      href: `${searchUrl}/tipo-Pickup`,
      title: 'Autos seminuevos Pick Up',
    },
    {
      icon: <BodyTypeCrossOverIcon />,
      name: f({ id: 'CROSSOVERS' }),
      href: `${searchUrl}/tipo-Crossover`,
      title: 'Autos seminuevos Crossover',
    },
  ]
  const paddingDirection = direction === 'column' ? sx.bodyTypesPaddingColumn : sx.bodyTypesPaddingRow
  const bodyType = direction === 'column' ? sx.bodyTypeColumn : sx.bodyTypeRow

  return (
    <Box
      sx={direction === 'column' ? sx.rootColumn : sx.rootRow}
      id="section5"
      {...addTestIdProp(testIdProp)}
      {...addIdProp(testIdProp)}
      pt={title ? 2 : 0}
    >
      <Container
        sx={{ ...bodyType, ...paddingDirection }}
        maxWidth={direction === 'column' ? 'xs' : 'lg'}
      >
        <Grid
          container
          justifyContent="center"
        >
          <Grid size={12}>
            <Typography
              sx={{ ...sx.bodyTypesTitle, ...titleStyles }}
              variant={varaintTitle}
              className={clsx({
                column: direction === 'column',
              })}
            >
              {title}
            </Typography>

            {description && (
              <Typography
                variant="body2"
                sx={sx.bodyTypesSubtitle}
              >
                {description}
              </Typography>
            )}
          </Grid>

          <Grid
            size={12}
            container
            spacing={1}
            sx={!isOverflow ? sxProps : sx.linksContainer}
            className={clsx({ row: direction === 'row' })}
            ref={linksContainer}
            onScroll={scrollCheck}
          >
            {bodyTypes.map((type) => (
              <Grid
                key={type.name}
                sx={sx.bodyType}
                size={{
                  xs: direction === 'column' ? 6 : 'auto',
                  sm: direction === 'column' ? 6 : 'auto',
                  md: direction === 'column' ? 6 : 'auto',
                }}
              >
                {type.href !== '#' ? (
                  <Box
                    component="a"
                    href={type.href}
                    sx={sx.link}
                  >
                    <Tile
                      sx={sx.tileItem}
                      icon={type.icon}
                      text={type.name}
                      className="button-secondary"
                      variant="row"
                      title={type.title}
                    />
                  </Box>
                ) : (
                  <Box
                    component="div"
                    sx={sx.link}
                  >
                    <Tile
                      sx={sx.tileItem}
                      icon={type.icon}
                      text={type.name}
                      className="button-secondary"
                      variant="row"
                    />
                  </Box>
                )}
              </Grid>
            ))}

            {direction === 'row' && (
              <Grid
                key={f({ id: 'SEE_ALL_VEHICLES' })}
                sx={sx.bodyType}
                size={{
                  xs: direction === 'column' ? 6 : 'auto',
                  sm: direction === 'column' ? 6 : 'auto',
                  md: direction === 'column' ? 6 : 'auto',
                }}
              >
                <Box
                  component="a"
                  href={f({ id: 'ROUTE_SEARCH' })}
                  sx={sx.lastLink}
                >
                  <Tile
                    sx={sx.tileItem}
                    text={f({ id: 'SEE_ALL_VEHICLES' })}
                    variant="row"
                    className="button-secondary see-more"
                  />
                </Box>
              </Grid>
            )}
          </Grid>
          {isOverflow && (
            <>
              {!scrolEnd && (
                <Button
                  variant="outline"
                  sx={direction === 'row' ? sx.btnRight : { display: 'none' }}
                  onClick={() => slide(+25)}
                  aria-label={f({ id: 'BOTTON_BACK' })}
                >
                  <IconRightSmallArrow />
                </Button>
              )}
              {scrollX !== 0 && (
                <Button
                  variant="outline"
                  sx={direction === 'row' ? sx.btnLeft : { display: 'none' }}
                  onClick={() => slide(-25)}
                  aria-label={f({ id: 'BOTTON_FORWARD' })}
                >
                  <IconLeftArrow />
                </Button>
              )}
            </>
          )}
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(QuickLinks)
